// measurements
export const FETCH_MEASUREMENTS = 'fetchMeasurements';

// warehouse locations
export const FETCH_WAREHOUSE_LOCATIONS = 'fetchWarehouseLocations';
